import { render, staticRenderFns } from "./StartSidebar.vue?vue&type=template&id=3f37b809"
import script from "./StartSidebar.vue?vue&type=script&lang=js"
export * from "./StartSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports